document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

class WnMenuDrawer extends HTMLElement {
  connectedCallback() {
    this.details = this.querySelector('details');
    this.panel = this.querySelector('[data-menu-panel]');
    this.closeButton = this.querySelector('[data-menu-close]');
    this.overlay = this.querySelector('[data-menu-overlay]');
    this.summary = this.details?.querySelector(':scope > summary');

    if (!this.details || !this.panel || !this.summary) return;

    this.onToggle = this.onToggle.bind(this);
    this.onKeydown = this.onKeydown.bind(this);
    this.close = this.close.bind(this);

    this.details.addEventListener('toggle', this.onToggle);
    this.closeButton?.addEventListener('click', this.close);
    this.overlay?.addEventListener('click', this.close);
    document.addEventListener('keydown', this.onKeydown);
  }

  disconnectedCallback() {
    this.details?.removeEventListener('toggle', this.onToggle);
    this.closeButton?.removeEventListener('click', this.close);
    this.overlay?.removeEventListener('click', this.close);
    document.removeEventListener('keydown', this.onKeydown);
  }

  focusableElements() {
    if (!this.panel) return [];
    return [...this.panel.querySelectorAll('a[href], button:not([disabled]), summary, input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')]
      .filter((element) => !element.hidden && element.offsetParent !== null);
  }

  onToggle() {
    if (this.details.open) {
      document.documentElement.setAttribute('data-menu-open', '');
      requestAnimationFrame(() => this.closeButton?.focus({ preventScroll: true }));
    } else {
      document.documentElement.removeAttribute('data-menu-open');
    }
  }

  onKeydown(event) {
    if (!this.details.open) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      this.close();
      return;
    }
    if (event.key !== 'Tab') return;

    const focusable = this.focusableElements();
    if (!focusable.length) {
      event.preventDefault();
      this.closeButton?.focus({ preventScroll: true });
      return;
    }

    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (!this.panel.contains(document.activeElement)) {
      event.preventDefault();
      (event.shiftKey ? last : first).focus();
    } else if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  close() {
    if (!this.details.open) return;
    this.details.open = false;
    this.summary.focus({ preventScroll: true });
  }
}

if (!customElements.get('wn-menu-drawer')) customElements.define('wn-menu-drawer', WnMenuDrawer);

const headerGroup = document.querySelector('.shopify-section-group-header-group');
if (headerGroup) {
  const updateHeaderHeight = () => {
    document.documentElement.style.setProperty('--wn-header-group-height', `${Math.ceil(headerGroup.getBoundingClientRect().height)}px`);
  };

  updateHeaderHeight();
  new ResizeObserver(updateHeaderHeight).observe(headerGroup);
  window.addEventListener('orientationchange', updateHeaderHeight, { passive: true });
}

document.addEventListener('shopify:section:load', () => {
  const region = document.querySelector('[data-live-region]');
  if (region) region.textContent = '';
});
